import React, { FC, ReactNode, useState, useEffect } from "react";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeaderFilter from "./HeaderFilter";
import StayCard from "components/StayCard/StayCard";
import config from "config.json";
import useFetch from "hooks/useFetch";

export interface SectionGridFeaturePlacesProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
}

interface HotelData {
  codigo: string;
  descripcion: string;
  ciudad: string;
  direccion: string;
  precio_por_noche: string;
  cant_lugares: number;
  banios_compartidos: number;
  banios_habitaciones: number;
}

interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageData {
  default_image: string;
  hoteles: HotelImage[];
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  stayListings = [],
  gridClass = "",
  heading = "Hoteles destacados",
  subHeading = "Hoteles en los que puedes hospedar tus vacaciones",
  headingIsCenter,
  tabs = ["Hoteles Destacados"],
}) => {
  
  const { data: hotelesData, error: hotelesError, fetchData: fetchHoteles } = useFetch<{ hoteles: HotelData[] }>('GET', `${config.backend_url}/setia/hoteles`, { 'Content-Type': 'application/json' });
  const { data: hotelImagesData, error: hotelImagesError, fetchData: fetchHotelImages } = useFetch<HotelImageData>('GET', `${config.backend_url}/setia/hoteles/ver_todas_fotos`, { 'Content-Type': 'application/json' });

  const [hoteles, setHoteles] = useState<HotelData[]>([]);
  const [hotelImages, setHotelImages] = useState<HotelImage[]>([]);

  useEffect(() => {
    fetchHoteles();
    fetchHotelImages();
  }, []);

  useEffect(() => {
    if (hotelesData) {
      setHoteles(hotelesData.hoteles);
    }
    if (hotelesError) {
      console.log(hotelesError);
    }
  }, [hotelesData, hotelesError]);

  useEffect(() => {
    if (hotelImagesData) {
      setHotelImages(hotelImagesData.hoteles); 
    }
    if (hotelImagesError) {
      console.log(hotelImagesError);
    }
  }, [hotelImagesData, hotelImagesError]);

  return (
    <div className="nc-SectionGridFeaturePlaces relative">
      <HeaderFilter
        tabActive={"Hoteles Destacados"}
        subHeading="Hoteles en los que puedes hospedar tus vacaciones"
        tabs={[]}
        heading="Hoteles destacados"
        onClickTab={() => { }}
      />
      <div className="grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {hoteles.filter((_, index) => index < 4).map((hotel) => {
          
          const images = hotelImages.filter(img => img.hotel_code === hotel.codigo);

          return (
            <StayCard
              key={hotel.codigo}
              hotel={hotel}
              hotelImages={images} 
              defaultImage={hotelImagesData?.default_image || ''}
            />
          );
        })}
      </div>
      <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary href={"/listing-stay"}>Ver más</ButtonPrimary>
      </div>
    </div>
  );
};

export default SectionGridFeaturePlaces;